
import React from 'react';
import { SearchX } from 'lucide-react';

interface NoResultsProps {
  platform?: string;
  message?: string;
}

const NoResults: React.FC<NoResultsProps> = ({ 
  platform,
  message 
}) => {
  const defaultMessage = platform
    ? `We couldn't find any apps for ${platform.toLowerCase()} with the selected filters. Try changing your filters.`
    : 'No results found matching your criteria. Try adjusting your filters.';

  return (
    <div className="text-center py-12 flex flex-col items-center">
      <SearchX className="h-12 w-12 text-gray-400 mb-4" />
      <h2 className="text-xl font-medium text-gray-900 mb-2">No apps found</h2>
      <p className="text-gray-600 max-w-md mx-auto">
        {message || defaultMessage}
      </p>
    </div>
  );
};

export default NoResults;
